import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B000220FindRequest = Partial<{
  shohinCd: string;
  shohinNmCriteria: string;
  shohinKana: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  sokoCd: string;
  shohinshubetsuKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000220FindResponse = {
  shohinCd: string;
  shohinNm: string;
  sokoCd: string;
  sokoNm: string;
  zaikosu: string;
  hikiatekanosu: string;
  janCd: string;
  sokoshubetsuKbn: string;
};

export const B000220Find = (props: B000220FindRequest) => {
  return RestClient.get<PageableResponse<B000220FindResponse[]>>(
    "b000220/find",
    {
      params: props,
    }
  );
};
